module.exports = __webpack_public_path__ + "img/BannerAcercaDe600x350.17ead9ad.jpg";